import React, { useEffect, useRef, useState } from "react";
import Aketch from "./images/ourTeam/Aketch.jpeg";
import Linet from "./images/ourTeam/Linet.jpeg";
import Liyosi from "./images/ourTeam/Liyosi.jpeg";
import Nita from "./images/ourTeam/Nita.jpeg";

const TEAM = [
  {
    id: "aketch",
    name: "Dr. Collins Aketch",
    role: "Dentist",
    img: Aketch,
    bio: "He is a dentist with years of experience in both private and public practice, having worked in renowned institutions such as The Aga Khan University Hospital Nairobi, Metropolitan Hospital and Kenyatta National Hospital, just to mention a few. He has special interests in aesthetic and restorative dentistry and attends both local and international courses to improve his skills.",
  },
  {
    id: "linet",
    name: "Linet",
    role: "Dental Assistant",
    img: Linet,
    bio: "She is a dental assistant with over two decades of experience. She is ever happy and grateful to have a job she fully enjoys, and her life is deeply fulfilled by this career. Working at Yaya Dental Clinic has been a wonderful experience that has given her exposure and maximum experience. She loves the excellence of the team she works with.",
  },
  {
    id: "liyosi",
    name: "Dr. Collins Liyosi",
    role: "Dental Practitioner",
    img: Liyosi,
    bio: "A dental practitioner who leans towards pediatric dentistry. With several years of experience in both private and public sectors, he's managed a wide range of dental issues from jaw fractures to dental emergencies. He strives to improve his skills through hands-on courses organized locally and internationally, for the full satisfaction of patients.",
  },
  {
    id: "nita",
    name: "Nita",
    role: "Dental Assistant",
    img: Nita,
    bio: "She is an ever jovial and friendly dental assistant who assists the dentists in all dental procedures and performs clerical duties related to dental programs.",
  },
];

const CSS = `
@import url("https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600&family=Young+Serif&display=swap");

.ot {
  --ot-ink: #10303a;
  --ot-body: #3f5a62;
  --ot-teal: #0d7a85;
  --ot-teal-dark: #0a5f68;
  --ot-mist: #eaf4f3;
  --ot-line: #d3e5e4;
  --ot-paper: #ffffff;
  font-family: "Figtree", system-ui, -apple-system, "Segoe UI", sans-serif;
  color: var(--ot-body);
  background: linear-gradient(180deg, var(--ot-mist) 0%, #ffffff 55%);
  padding: clamp(3.5rem, 9vw, 7rem) clamp(1rem, 4vw, 2.5rem) clamp(3rem, 7vw, 5rem);
}
.ot *, .ot *::before, .ot *::after { box-sizing: border-box; }
.ot-wrap { max-width: 72rem; margin: 0 auto; }

.ot-head { max-width: 40rem; margin: 0 auto clamp(2rem, 5vw, 3.5rem); text-align: center; }
.ot-title {
  font-family: "Young Serif", Georgia, serif;
  font-weight: 400;
  color: var(--ot-ink);
  font-size: clamp(1.9rem, 1.2rem + 3.2vw, 3.1rem);
  line-height: 1.1;
  letter-spacing: -0.01em;
  margin: 0 0 1rem;
  text-wrap: balance;
}
.ot-lede { font-size: clamp(1rem, 0.95rem + 0.25vw, 1.15rem); line-height: 1.65; margin: 0; text-wrap: pretty; }

.ot-grid {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: clamp(1rem, 2.5vw, 1.75rem);
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 15.5rem), 1fr));
}

.ot-card {
  display: flex;
  flex-direction: column;
  background: var(--ot-paper);
  border: 1px solid var(--ot-line);
  border-radius: 1.25rem;
  overflow: hidden;
  transition: border-color 0.2s ease, transform 0.2s ease;
}
.ot-card:hover { border-color: var(--ot-teal); }

.ot-photo { aspect-ratio: 4 / 5; background: var(--ot-mist); overflow: hidden; }
.ot-photo img { width: 100%; height: 100%; object-fit: cover; object-position: center top; display: block; }

.ot-info { display: flex; flex-direction: column; gap: 0.2rem; padding: 1.1rem 1.25rem 1.35rem; flex: 1; }
.ot-name { font-size: 1.15rem; font-weight: 600; color: var(--ot-ink); margin: 0; line-height: 1.3; }
.ot-role { margin: 0 0 0.9rem; font-size: 0.95rem; color: var(--ot-teal-dark); }

.ot-btn {
  margin-top: auto;
  align-self: flex-start;
  font: inherit;
  font-weight: 600;
  font-size: 0.95rem;
  color: var(--ot-teal-dark);
  background: transparent;
  border: 1.5px solid var(--ot-teal);
  border-radius: 999px;
  padding: 0.6rem 1.15rem;
  min-height: 2.75rem;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}
.ot-btn:hover { background: var(--ot-teal); color: #fff; }
.ot-btn:focus-visible, .ot-close:focus-visible { outline: 3px solid #f0b429; outline-offset: 3px; }

/* Dialog */
.ot-overlay {
  position: fixed;
  inset: 0;
  z-index: 1055;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background: rgba(10, 35, 42, 0.6);
  padding: 0;
  animation: ot-fade 0.18s ease-out;
}
.ot-dialog {
  position: relative;
  width: 100%;
  max-height: 88vh;
  max-height: 88dvh;
  overflow-y: auto;
  background: #fff;
  color: var(--ot-body);
  border-radius: 1.5rem 1.5rem 0 0;
  padding: 1.75rem 1.4rem calc(1.75rem + env(safe-area-inset-bottom, 0px));
  animation: ot-rise 0.22s ease-out;
}
.ot-person { display: flex; align-items: center; gap: 1rem; margin: 0 2.5rem 1.1rem 0; }
.ot-avatar { width: 4.25rem; height: 4.25rem; border-radius: 50%; object-fit: cover; object-position: center top; flex: none; border: 2px solid var(--ot-line); }
.ot-dlg-name { font-family: "Young Serif", Georgia, serif; font-weight: 400; font-size: clamp(1.25rem, 1rem + 1vw, 1.6rem); color: var(--ot-ink); margin: 0; line-height: 1.2; }
.ot-dlg-role { margin: 0.15rem 0 0; color: var(--ot-teal-dark); font-size: 0.95rem; }
.ot-bio { margin: 0; line-height: 1.7; font-size: 1rem; max-width: 60ch; text-wrap: pretty; }
.ot-close {
  position: absolute;
  top: 0.9rem;
  right: 0.9rem;
  width: 2.75rem;
  height: 2.75rem;
  border: 0;
  border-radius: 50%;
  background: var(--ot-mist);
  color: var(--ot-ink);
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
}
.ot-close:hover { background: var(--ot-line); }

@media (min-width: 40rem) {
  .ot-overlay { align-items: center; padding: 1.5rem; }
  .ot-dialog { max-width: 34rem; border-radius: 1.5rem; padding: 2rem; }
}

@keyframes ot-fade { from { opacity: 0; } to { opacity: 1; } }
@keyframes ot-rise { from { transform: translateY(1.5rem); opacity: 0; } to { transform: none; opacity: 1; } }

@media (prefers-reduced-motion: reduce) {
  .ot-overlay, .ot-dialog { animation: none; }
  .ot-card, .ot-btn { transition: none; }
}
`;

export default function OurTeam() {
  const [active, setActive] = useState(null);
  const closeRef = useRef(null);
  const triggerRef = useRef(null);

  const open = (member, e) => {
    triggerRef.current = e.currentTarget;
    setActive(member);
  };
  const close = () => setActive(null);

  useEffect(() => {
    if (!active) return undefined;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    closeRef.current?.focus();

    const onKey = (e) => {
      if (e.key === "Escape") setActive(null);
    };
    document.addEventListener("keydown", onKey);

    return () => {
      document.body.style.overflow = prevOverflow;
      document.removeEventListener("keydown", onKey);
      triggerRef.current?.focus();
    };
  }, [active]);

  return (
    <section className="ot" aria-labelledby="ot-title">
      <style>{CSS}</style>

      <div className="ot-wrap">
        <header className="ot-head">
          <h1 id="ot-title" className="ot-title">
            Meet our exceptional team
          </h1>
          <p className="ot-lede">
            Skilled, caring people who put your comfort first, from routine
            check-ups to restorative care.
          </p>
        </header>

        <ul className="ot-grid">
          {TEAM.map((m) => (
            <li key={m.id} className="ot-card">
              <div className="ot-photo">
                <img src={m.img} alt={`Portrait of ${m.name}`} loading="lazy" />
              </div>
              <div className="ot-info">
                <h2 className="ot-name">{m.name}</h2>
                <p className="ot-role">{m.role}</p>
                <button
                  type="button"
                  className="ot-btn"
                  onClick={(e) => open(m, e)}
                  aria-haspopup="dialog"
                  aria-label={`Read more about ${m.name}`}
                >
                  Read bio
                </button>
              </div>
            </li>
          ))}
        </ul>
      </div>

      {active && (
        <div
          className="ot-overlay"
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) close();
          }}
        >
          <div
            className="ot-dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby="ot-dlg-name"
          >
            <button
              ref={closeRef}
              type="button"
              className="ot-close"
              onClick={close}
              aria-label="Close"
            >
              &times;
            </button>
            <div className="ot-person">
              <img className="ot-avatar" src={active.img} alt="" />
              <div>
                <h2 id="ot-dlg-name" className="ot-dlg-name">
                  {active.name}
                </h2>
                <p className="ot-dlg-role">{active.role}</p>
              </div>
            </div>
            <p className="ot-bio">{active.bio}</p>
          </div>
        </div>
      )}
    </section>
  );
}
